import { render, staticRenderFns } from "./StudentQuestions.vue?vue&type=template&id=5f706c36&scoped=true&"
import script from "./StudentQuestions.vue?vue&type=script&lang=ts&"
export * from "./StudentQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./StudentQuestions.vue?vue&type=style&index=0&id=5f706c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f706c36",
  null
  
)

export default component.exports